"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { Sidebar, SidebarContent, SidebarFooter, SidebarHeader, SidebarRail } from "@components/ui/sidebar";
import { useAppSelector } from "@lib/redux/hooks";
import { selectAuth } from "@features/application/app-selectors";
import { AppSidebarUtilityActions } from "@features/application/ui/app-sidebar-utility-actions";
import { NavApplication } from "@features/application/ui/nav-app";
import { NavUser } from "@features/auth/ui/nav-user";
import { NavEvent } from "@features/events/ui/nav-event";
import { NavWorkspace } from "@features/workspaces/ui/nav-workspace";
import { WorkspaceSwitcher } from "@features/workspaces/ui/workspace-switcher";
interface AppSidebarProps {
  isPrivateMode?: boolean;
  showDesignSystemUtilityAction?: boolean;
}

/**
 * Represents the application sidebar component which acts as a customizable and collapsible navigation area.
 *
 * AppSidebar combines various child components to provide a comprehensive structure for navigation.
 * - The header contains a team switcher, allowing workspaces to toggle between multiple teams or groups.
 * - The content area includes navigation for primary items and project-related links.
 * - The footer provides user-related functionalities.
 * - An additional rail layout is included for extended navigation or quick actions.
 *
 * @param isPrivateMode - Indicates whether the sidebar is in private mode, where only accessible workspaces are displayed.
 * @param {React.ComponentProps<typeof Sidebar>} props - Props to be passed to the Sidebar component.
 */
export const AppSidebar = t0 => {
  const $ = _c(20);
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      isPrivateMode: t1,
      showDesignSystemUtilityAction: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
    $[3] = t2;
  } else {
    props = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  const isPrivateMode = t1 === undefined ? false : t1;
  const showDesignSystemUtilityAction = t2 === undefined ? false : t2;
  const auth = useAppSelector(selectAuth);
  let t3;
  if ($[4] !== auth.isAuthenticated || $[5] !== isPrivateMode) {
    t3 = auth.isAuthenticated && <><SidebarHeader><WorkspaceSwitcher /></SidebarHeader><SidebarContent><NavApplication isPrivateMode={isPrivateMode} /><NavWorkspace isPrivateMode={isPrivateMode} /><NavEvent isPrivateMode={isPrivateMode} /></SidebarContent></>;
    $[4] = auth.isAuthenticated;
    $[5] = isPrivateMode;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== isPrivateMode || $[8] !== showDesignSystemUtilityAction) {
    t4 = <AppSidebarUtilityActions showDesignSystem={showDesignSystemUtilityAction} isPrivateMode={isPrivateMode} />;
    $[7] = isPrivateMode;
    $[8] = showDesignSystemUtilityAction;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== isPrivateMode) {
    t5 = <NavUser isPrivateMode={isPrivateMode} />;
    $[10] = isPrivateMode;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <SidebarFooter>{t4}{t5}</SidebarFooter>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <SidebarRail />;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== props || $[17] !== t3 || $[18] !== t6) {
    t8 = <Sidebar collapsible="icon" {...props}>{t3}{t6}{t7}</Sidebar>;
    $[16] = props;
    $[17] = t3;
    $[18] = t6;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};